import { render, staticRenderFns } from "./FeedContentCompanyResponseCompanyProcess.vue?vue&type=template&id=ca2aceda"
import script from "./FeedContentCompanyResponseCompanyProcess.vue?vue&type=script&lang=js"
export * from "./FeedContentCompanyResponseCompanyProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports